module.exports = "/shifts/components/salesSummaryComponent-28cb97.html";